export const minLeasingPrepayment = 40;

export const leasingInfo = `Сумма аванса свыше ${minLeasingPrepayment}% вносится в первый лизинговый платеж`;
